import React from 'react';

import { useIntl, FormattedMessage } from 'react-intl';

import PromptMessage from '@/components/UI/PromptMessage';
import { openZendesk } from '@/components/Zendesk';

const VerifySectionHeader = ({
  isAccountVerified,
  kycDocumentsEmpty,
}: {
  isAccountVerified: boolean;
  kycDocumentsEmpty: boolean;
}): JSX.Element => {
  const intl = useIntl();

  if (!kycDocumentsEmpty) {
    if (isAccountVerified) {
      return (
        <PromptMessage
          className="all-done"
          type="success"
          message={intl.formatMessage({ id: 'settings.verify.successMessage' })}
        />
      );
    }

    return (
      <PromptMessage
        type="info"
        message={
          <FormattedMessage
            id="settings.verify.introText"
            values={{
              a: str => (
                <span
                  onClick={() => openZendesk()}
                  className="text-blue-light font-bold underline cursor-pointer"
                >
                  {str}
                </span>
              ),
            }}
          />
        }
      />
    );
  }

  return (
    <PromptMessage
      type="info"
      message={intl.formatMessage({ id: 'settings.verify.nothingRequestedMessage' })}
    />
  );
};

export default VerifySectionHeader;
